<template>
  <v-card class="box-container ma-0 pa-0" style="width: 100%; height: 100%; overflow: hidden" fluid fill-height>
    <loading
      :can-cancel="cancelProg"
      :on-cancel="
        () => {
          isLoading = false;
        }
      "
      :background-color="$vuetify.theme.dark ? '#000' : '#FFF'"
      :color="$vuetify.theme.dark ? '#FFF' : '#000'"
      loader="bars"
      :active.sync="isLoading"
      :opacity="0.9"
    >
      <span slot="after">
        <br />
        {{ "Програмиране на артикул " + loaderValue + " от " + articlesCountMax }}
      </span>
    </loading>
    <v-dialog v-if="dialogReport" v-model="dialogReport" :overlay-opacity="0.92" persistent max-width="320" style="z-index: 9999999">
      <v-card>
        <v-card-title>Ненулев артикулен отчет</v-card-title>
        <v-card-actions class="mx-4">
          <span>Преди да програмирате артикулите е необходимо да направите артикулен отчет с нулиране.</span>
        </v-card-actions>
        <v-card-actions class="mx-4" v-if="!isOnMobile">
          <span>Желаете ли да направите отчета?</span>
        </v-card-actions>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogReport = false" color="warning" tile>Отказ</v-btn>
          <v-btn @click="printArticleReport()" color="success" tile>ОК</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="row-header ma-0 pa-0" ref="refHeaders">
      <v-row class="ma-0 pl-3 pb-1" justify="center" align="center">
        <v-spacer></v-spacer>
        <span class="title">
          <b>Програмиране на артикули</b>
        </span>
        <v-spacer></v-spacer>
        <v-btn color="error" text fab small @click="closeProgArt">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
      <v-divider class="ma-0 pa-0"></v-divider>
      <v-row class="pa-0 mx-3 mt-3" justify="space-between">
        <v-text-field @input="fixName(searchText)" v-model="searchText" outlined label="Търсене" dense></v-text-field>
        <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="mx-2 elevation-0" @click="addArticle">
          <v-icon color="#1685c9" left>mdi-plus</v-icon>
          <span>Добави</span>
        </v-btn>
        <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="mx-2 elevation-0" @click="$refs.fileUpload.click()">
          <v-icon color="#1685c9" left>mdi-database-import</v-icon>
          <span>Импорт</span>
          <input type="file" accept=".txt" name="articles" id="file" ref="fileUpload" v-on:change="importArticles" style="display: none" />
        </v-btn>
        <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="mx-2 elevation-0" @click="exportArticles" :disabled="fp.articles.length == 0">
          <v-icon color="#1685c9" left>mdi-database-export</v-icon>
          <span>Експорт</span>
        </v-btn>
        <v-btn :color="isInDarkMode ? '' : 'blue lighten-4'" tile class="mx-2 elevation-0" @click="callProgPlu" :disabled="selected.length == 0">
          <v-icon color="#1685c9" left>mdi-content-save</v-icon>
          <span>Запази</span>
        </v-btn>
      </v-row>
    </div>

    <v-form class="row-content ma-0 pa-0" v-on:submit.prevent lazy-validation ref="refVirtualScrollerContainer">
      <v-virtual-scroll ref="refVirtualScroller" :items="searchPlu" :item-height="75" :width="virtualScrollerWidth" :height="virtualScrollerHeight" id="progVirtualScroll">
        <template v-slot="{ item }">
          <v-list-item :key="item.PLUNum" class="ma-0 pa-0">
            <v-row class="ma-0 pa-0" align="center" justify="center">
              <v-col cols="1" class="ma-0 pa-1">
                <v-text-field :small="isOnMobile" @focus="$event.target.select()" :value="`${item.PLUNum}`" label="№" dense outlined class="ma-0 pa-0 centered-input" disabled></v-text-field>
              </v-col>
              <v-col cols="3" class="ma-0 pa-1">
                <v-row class="ma-0 pa-0">
                  <v-text-field @focus="$event.target.select()" :rules="pluName_Rule" @input="fixName(item), shoveInForProgramming(item)" label="Име" class="ma-0 pa-0" dense outlined v-model="item.PLUName" />
                </v-row>
              </v-col>
              <v-col cols="2" class="ma-0 pa-1">
                <v-text-field
                  v-model="item.Barcode"
                  @focus="$event.target.select()"
                  @keyup.enter.prevent="findBarcode(item)"
                  @input="
                    fixName(item);
                    shoveInForProgramming(item);
                  "
                  label="Баркод"
                  :rules="pluBarcode_Rule"
                  class="ma-0 pa-0"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="2" class="ma-0 pa-1">
                <v-text-field @focus="$event.target.select()" :rules="pluPrice_Rule" @input="shoveInForProgramming(item)" label="Цена" class="ma-0 pa-0 centered-input" style="max-width: 100%" dense outlined v-model.number="item.Price" type="number"></v-text-field>
              </v-col>
              <v-col :cols="fp.isNew ? 1 : 2" class="ma-0 pa-1">
                <v-select @input="shoveInForProgramming(item)" label="Дан. гр." dense outlined :items="returnVAT_groups" v-model="item.OptionVATClass" class="ma-0 pa-0"></v-select>
              </v-col>
              <v-col v-if="fp.isNew" cols="1" class="ma-0 pa-1">
                <v-select @input="shoveInForProgramming(item)" label="Св. цена" dense outlined :items="returnOptionPrices" value="value" v-model="item.OptionPrice" class="ma-0 pa-0"></v-select>
              </v-col>
              <v-col cols="2" class="ma-0 pa-1">
                <!-- <v-text-field @focus="$event.target.select()" :rules="pluDep_Rule" @input="shoveInForProgramming(item)" dense label="Департамент" outlined class="ma-0 pa-0 centered-input" v-model="item.BelongToDepNumber" type="number"></v-text-field> -->
                <v-select
                  @focus="$event.target.select()"
                  :rules="pluDep_Rule"
                  @input="shoveInForProgramming(item)"
                  dense
                  label="Департамент"
                  outlined
                  class="ma-0 pa-0 centered-input"
                  v-model="item.BelongToDepNumber"
                  item-value="DepNum"
                  :items="fp.departments"
                  :item-text="
                    (d) => {
                      return d.DepNum == 0 ? '' : d.DepNum + '. ' + d.DepName;
                    }
                  "
                  type="number"
                ></v-select>
              </v-col>
            </v-row>
          </v-list-item>
        </template>
      </v-virtual-scroll>
    </v-form>
  </v-card>
</template>

<script>
import Const from "../constants.js";
import Tremol from "../assets/fp/fp";
import Loading from "vue-loading-overlay";
import Filesaver from "file-saver";
import iconv from "iconv-lite";
// import JSZip from "jszip";

export default {
  components: {
    Loading,
  },
  data() {
    return {
      virtualScrollerWidth: "100%",
      virtualScrollerHeight: "100%",
      intervalRecalcSize: null,
      dialogReport: false,
      cancelProg: false,
      searchText: "",
      isLoading: false,
      selected: [],
      articles: [],
      loaderValue: 0,
      departmentsCountMax: 41,
      pluName_Rule: [
        (v) => {
          if (v || v === 0) {
            return true;
          } else {
            return "Задължително поле";
          }
        },
        (v) => (this.fp.isNew ? v.length <= 32 || "Името не може да бъде повече от 32 символа!" : v.length <= 20 || "Името не може да бъде повече от 20 символа!"),
      ],
      pluPrice_Rule: [
        (v) => {
          if (!!v || v === 0) {
            return true;
          } else {
            return "Невалидна цена!";
          }
        },
        (v) => v.toString().length <= 9 || "Цената не може да превишава 9 символа!",
        (v) => /^(\d{1,6}|\d{0,6}\.\d{1,2})$/.test(v) || "Невалидна цена!",
      ],
      pluDep_Rule: [
        (v) => {
          if (v || v === 0) {
            return true;
          } else {
            return "Задължително поле";
          }
        },
        (v) => (v >= 0 && v < this.departmentsCountMax) || "Невалиден номер",
      ],
      pluBarcode_Rule: [(v) => v.toString().length <= 13 || "Баркодът не може да превишава 13 символа!"],
    };
  },

  computed: {
    articlesCountMax() {
      return this.selected.length;
    },
    searchPlu() {
      if (this.searchText == "") {
        return this.articles;
      } else {
        return this.articles.filter((article) => {
          return article.PLUName.toLowerCase().includes(this.searchText.toLowerCase()) || article.Price.toString().includes(this.searchText.toString().toLowerCase()) || article.Barcode.toString().includes(this.searchText.toString().toLowerCase());
        });
      }
    },
    returnOptionPrices() {
      return [
        { text: "Не", value: 0 },
        { text: "Да", value: 1 },
      ];
    },
    returnVAT_groups() {
      let vats = Object.values(Tremol.Enums.OptionVATClass);
      const index = vats.indexOf("*");
      if (index > -1) vats.splice(index, 1);
      vats.length = 4;
      return vats;
    },
  },
  methods: {
    findBarcode() {
      //TODO ?
    },
    fixName(item) {
      if (item.PLUName && item.PLUName.indexOf("@") > -1) {
        item.PLUName = item.PLUName.split("@").join(" ");
      }
      if (item.Barcode && item.Barcode.indexOf("@") > -1) {
        item.Barcode = item.Barcode.split("@").join(" ");
      }
    },
    addArticle() {
      try {
        let article = {
          PLUName: "",
          Barcode: "",
          Price: Number(null),
          OptionVATClass: "Б",
          BelongToDepNumber: 0,
        };
        if (this.articles.length == 0) {
          article.PLUNum = 1;
        } else {
          let pluNum = Math.max.apply(
            Math,
            this.articles.map(function (plu) {
              return plu.PLUNum;
            })
          );
          article.PLUNum = pluNum + 1;
        }

        this.articles.push(article);

        this.$refs.refVirtualScrollerContainer.validate();
        this.$nextTick(() => {
          this.$refs.refVirtualScroller.$el.scrollTop = this.$refs.refVirtualScroller.$el.scrollHeight;
        });
      } catch (err) {
        this.fp.handleException(err);
      }
    },
    importArticles() {
      try {
        let vm = this;

        let file = this.$refs.fileUpload.files[0];
        if (!file || file.type !== "text/plain") {
          throw new Error("Невалиден формат!");
        }
        vm.selected = [];
        vm.articles = [];
        let reader = new FileReader();
        reader.readAsText(file, "windows-1251");
        reader.onload = (evt) => {
          let res = evt.target.result.split("\n").slice(0, -1);
          try {
            res.forEach((plu) => {
              let p = plu.split("\t");
              if (p.length != 10 && p.length != 19) {
                vm.selected = [];
                vm.articles = [];
                throw new Error("Невалидно съдържание!");
              }
              let barcode = p[2] * 1 == 0 ? "" : (p[2] * 1).toString();
              let art = {};
              art.PLUNum = p[0];
              art.PLUName = p[1];
              art.Barcode = barcode;
              art.Price = Number(p[3]);
              let vat = (vatRate) => {
                switch (vatRate) {
                  case "A":
                    return "А";
                  case "B":
                    return "Б";
                  case "C":
                    return "В";
                  case "D":
                    return "Г";
                  case "E":
                    return "Д";
                  case "F":
                    return "Е";
                  case "G":
                    return "Ж";
                  case "H":
                    return "З";
                }
              };
              if (p.length == 10) {
                art.OptionVATClass = vat(p[4]);
                art.BelongToDepNumber = p[5];
              } else if (p.length == 19) {
                art.OptionVATClass = vat(p[6]);
                art.BelongToDepNumber = p[9];
              }
              art.OptionPrice = 1; //TODO
              vm.selected.push(Object.assign({}, art));
              vm.articles.push(Object.assign({}, art));
            });
          } catch (err) {
            vm.fp.handleException(err);
          }
        };
        reader.onerror = (evt) => {
          throw evt;
        };
      } catch (ex) {
        this.fp.handleException(ex);
      }
    },
    exportArticles() {
      try {
        let forExport = [];
        this.articles.forEach((plu) => {
          let vat = (vatRate) => {
            switch (vatRate) {
              case "А":
                return "A";
              case "Б":
                return "B";
              case "В":
                return "C";
              case "Г":
                return "D";
              case "Д":
                return "E";
              case "Е":
                return "F";
              case "Ж":
                return "G";
              case "З":
                return "H";
            }
          };
          let article = plu.PLUNum + "\t" + plu.PLUName + "\t" + plu.Barcode + "\t" + plu.Price + "\t" + 0 + "\t" + "" + "\t" + vat(plu.OptionVATClass) + "\t" + 0 + "\t" + "\t" + plu.BelongToDepNumber + "\t" + "0.000" + "\t" + 0 + "\t" + "\t" + "\t" + "\t" + "\t" + "\t" + "\t" + "\r\n";
          forExport.push(iconv.encode(article, "win1251"));
        });
        let blob = new Blob(forExport, { type: "text/plain; charset=windows-1251;" });
        Filesaver.saveAs(blob, "articles.txt");

        //   let zip = new JSZip();
        // zip.file("README.txt", "За да програмирате експортнатите артикули директно на фискалното устройство, можете да използвате един от двата метода: \n 1 - ECR Manager \n 2 - Импортиране директно във фискалното устройство чрез външна SD карта.");
        // zip.file("BCKP/articles.txt", blob);
        // zip.generateAsync({ type: "blob" }).then(function(content) {
        //   Filesaver.saveAs(content, "articles.zip");
        // });
      } catch (ex) {
        this.fp.handleException(ex);
      }
    },
    shoveInForProgramming(plu) {
      let plu_Original = this.fp.articles.find((article) => article.PLUNum == plu.PLUNum);
      if (typeof plu_Original === "undefined") {
        if (this.selected.indexOf(plu) == -1) {
          this.selected.push(plu);
        }
      } else {
        if (plu_Original.PLUName != plu.PLUName || plu_Original.Price != plu.Price || plu_Original.OptionVATClass != plu.OptionVATClass || plu_Original.BelongToDepNumber != plu.BelongToDepNumber || plu_Original.Barcode != plu.Barcode || plu_Original.OptionPrice != plu.OptionPrice) {
          if (this.selected.indexOf(plu) == -1) {
            this.selected.push(plu);
          }
        }
      }
    },
    async callProgPlu() {
      try {
        if (this.$refs.refVirtualScrollerContainer.validate()) {
          this.loaderValue = 0;
          this.isLoading = true;
          await this.progPlu();
        } else {
          throw new Error("Намерен артикул с невалидни данни!");
        }
      } catch (ex) {
        this.fp.handleException(ex);
      }
    },
    async progPlu() {
      //   await this.fp.executeWithLoader(async () => {
      try {
        if (this.cancelProg) {
          this.loaderValue = 0;
          this.cancelProg = false;
          return;
        }
        let pluToProgram = this.selected[this.loaderValue];
        if (this.loaderValue >= this.selected.length || this.loaderValue >= this.fp.maxSupportedArts) {
          this.selected.forEach((plu) => {
            plu.Price = Number(plu.Price);
            plu.isVisible = true;
            let index = this.fp.articles.indexOf(this.fp.articles.find((article) => article.PLUNum == plu.PLUNum));
            if (index != -1) {
              this.$set(this.fp.articles, index, plu);
            } else {
              this.fp.articles.push(Object.assign({}, plu));
            }

            // this.fp.articles[index] = plu;
          });
          this.fp.setInfoMessage("Успешно програмиране на артикули.");

          this.selected = [];

          this.loaderValue = 0;
          this.isLoading = false;
          this.refreshArticles();
        } else {
          let barcode = String(Number(pluToProgram.Barcode.trim())).padStart(13, "0");

          let plu_Original = this.fp.articles.find((plu) => plu.PLUNum == pluToProgram.PLUNum);

          if (typeof plu_Original === "undefined") {
            if (barcode != "0000000000000") {
              await this.fp.ProgPLUbarcode(pluToProgram.PLUNum, barcode);
            }
            if (this.fp.isNew) {
              await this.fp.ProgPLUgeneral(pluToProgram.PLUNum, pluToProgram.PLUName, pluToProgram.Price, pluToProgram.OptionPrice, pluToProgram.OptionVATClass, pluToProgram.BelongToDepNumber, 0);
            } else {
              await this.fp.ProgPLU_Old(pluToProgram.PLUNum, pluToProgram.PLUName, pluToProgram.Price, pluToProgram.OptionVATClass, pluToProgram.BelongToDepNumber);
            }
          } else {
            if (pluToProgram.Barcode != plu_Original.Barcode) await this.fp.ProgPLUbarcode(pluToProgram.PLUNum, barcode);

            if (this.fp.isNew) {
              if (pluToProgram.PLUName != plu_Original.PLUName || pluToProgram.OptionVATClass != plu_Original.OptionVATClass || pluToProgram.BelongToDepNumber != plu_Original.BelongToDepNumber || pluToProgram.OptionPrice != plu_Original.OptionPrice) {
                await this.fp.ProgPLUgeneral(pluToProgram.PLUNum, pluToProgram.PLUName, pluToProgram.Price, pluToProgram.OptionPrice, pluToProgram.OptionVATClass, pluToProgram.BelongToDepNumber, 0);
              } else {
                if (pluToProgram.Price != plu_Original.Price) {
                  await this.fp.ProgPLUprice(pluToProgram.PLUNum, pluToProgram.Price, pluToProgram.OptionPrice);
                }
              }
            } else {
              if (pluToProgram.PLUName != plu_Original.PLUName || pluToProgram.Price != plu_Original.Price || pluToProgram.OptionVATClass != plu_Original.OptionVATClass || pluToProgram.BelongToDepNumber != plu_Original.BelongToDepNumber) {
                await this.fp.ProgPLU_Old(pluToProgram.PLUNum, pluToProgram.PLUName, pluToProgram.Price, pluToProgram.OptionVATClass, pluToProgram.BelongToDepNumber);
              }
            }
          }
          this.loaderValue++;
          await this.progPlu();
        }
      } catch (ex) {
        // this.articles = [];
        // this.selected = [];
        this.loaderValue = 0;
        this.isLoading = false;
        if (ex instanceof Tremol.ServerError) {
          if (ex.isFpException && ex.ste2 === 0x33) {
            this.dialogReport = true;
          } else {
            this.fp.handleException(ex);
          }
        }
      }
      // });
    },
    closeProgArt() {
      this.fp.exitMode(Const.Modes.ProgramArticles);
    },
    async printArticleReport() {
      await this.fp.executeWithLoader(async () => {
        try {
          await this.fp.PrintArticleReport(Tremol.Enums.OptionZeroing.Zeroing);
        } catch (ex) {
          this.fp.handleException(ex);
        }
        this.dialogReport = false;
      });
    },
    refreshArticles() {
      this.articles = [];
      this.fp.articles.forEach((plu) => {
        this.articles.push(Object.assign({}, plu));
      });
    },
    recalcWidthHeight() {
      if (this.intervalRecalcSize) clearInterval(this.intervalRecalcSize);
      this.intervalRecalcSize = setTimeout(() => {
        if (!this.$refs.refVirtualScrollerContainer) return;
        this.virtualScrollerWidth = this.$refs.refVirtualScrollerContainer.clientWidth;
        this.virtualScrollerHeight = window.innerHeight - this.$refs.refHeaders.clientHeight;
        //this.virtualScrollerHeight = this.$refs.refVirtualScrollerContainer.clientHeight;
        //if (this.virtualScrollerHeight > this.deviceHeight * this.getDevices.length) this.virtualScrollerHeight = this.deviceHeight * this.getDevices.length;
      }, 333);
    },
  },
  mounted() {
    this.recalcWidthHeight();
    this.refreshArticles();
    window.addEventListener("resize", this.recalcWidthHeight);
  },
  updated() {
    this.recalcWidthHeight();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.recalcWidthHeight);
  },
};
</script>

<style>
.v-select-list .v-list-item .v-list-item__content .v-list-item__title .v-select__selections {
  text-align: center;
}
</style>